import React, { useState } from "react";
import { TCenikQuery } from "./Cenik";
import { RiCloseFill } from "react-icons/ri";
import Button from "../../ui/Button/Button";
import Input from "../../ui/Input/Input";
import { BsSearch } from "react-icons/bs";

interface IProps {
  cenikQuery: TCenikQuery | null;
  setCenikQuery: (cenikQuery: TCenikQuery | null) => void;
}

export const CenikInputs = ({
  setCenikQuery,
  cenikQuery,
}: IProps): React.ReactElement<IProps> => {
  const [query, setQuery] = useState("");
  const [kod, setKod] = useState("");
  const [sirka, setSirka] = useState("");
  const [vyska, setVyska] = useState("");

  const clearInputs = () => {
    setQuery("");
    setKod("");
    setSirka("");
    setVyska("");
    setCenikQuery(null);
  };

  return (
    <div className="searchInputs">
      <div className="nazev-kod">
        <div>
          <div className="input-placeholder">Názov</div>
          <Input value={query} onChange={(e) => setQuery(e.target.value)} />
        </div>
        <div>
          <div className="input-placeholder">Kód</div>
          <Input value={kod} onChange={(e) => setKod(e.target.value)} />
        </div>
      </div>

      <div className="sirka-vyska">
        <div>
          <div className="input-placeholder">Šírka</div>
          <Input
            type="number"
            min={1}
            value={sirka}
            onChange={(e) => setSirka(e.target.value)}
          />
        </div>
        <div>
          <div className="input-placeholder">Výška</div>
          <Input
            min={1}
            type="number"
            value={vyska}
            onChange={(e) => setVyska(e.target.value)}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
        }}
      >
        <Button
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          disabled={query === "" && sirka === "" && kod === "" && vyska === ""}
          onClick={() => {
            setCenikQuery({ kod, sirka, vyska, query });
          }}
        >
          <BsSearch
            size={17}
            style={{
              marginRight: 16,
            }}
          />
          HĽADAŤ
        </Button>
        {cenikQuery ? (
          <Button
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: 10,
            }}
            onClick={clearInputs}
          >
            <RiCloseFill
              size={15}
              style={{
                marginRight: 8,
              }}
            />
            VYMAZAT FILTR
          </Button>
        ) : null}
      </div>
    </div>
  );
};
